import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router";
import type { PublicDocumentDto } from "@klantpunt/shared";
import { BrandMark } from "../app/BrandMark";
import { IconDownload } from "../app/icons";
import { fmtDate, fmtSize } from "../features/dossier/useDossier";
import { api, ApiError } from "../lib/api";

/** Deellink uit het dossier (/d/<token>): één document bekijken en downloaden zonder in te loggen. */
export function SharePage() {
  const { token = "" } = useParams();
  const q = useQuery({
    queryKey: ["share-public", token],
    queryFn: () => api<PublicDocumentDto>(`/public/d/${encodeURIComponent(token)}`),
    retry: false,
  });
  const d = q.data;
  return (
    <div className="qrpublic">
      <header className="qrhead">
        <BrandMark />
      </header>
      <main className="page narrow">
        {q.isPending ? (
          <p className="muted" role="status">
            Document ophalen…
          </p>
        ) : !d ? (
          <>
            <h1 className="dot">Gedeeld document</h1>
            <div className="alert" role="alert">
              {q.error instanceof ApiError ? q.error.message : "Deze link is verlopen of ingetrokken"}
            </div>
            <p className="muted small">Vraag degene die de link stuurde om een nieuwe.</p>
          </>
        ) : (
          <>
            <p className="muted small">
              {d.org} · {d.building}
            </p>
            <h1 className="dot">{d.title}</h1>
            <dl className="kv panel doc-public">
              <dt>Soort</dt>
              <dd>{d.typeName}</dd>
              <dt>Versie</dt>
              <dd>
                {d.version}
                {d.revision && ` · rev. ${d.revision}`}
              </dd>
              {d.validUntil && (
                <>
                  <dt>Geldig tot</dt>
                  <dd>{fmtDate(d.validUntil)}</dd>
                </>
              )}
              <dt>Bestand</dt>
              <dd className="dir-wrap">
                {d.fileName} <span className="muted small">{fmtSize(d.size)}</span>
              </dd>
            </dl>
            <a
              className="btn primary"
              href={`/api/public/d/${encodeURIComponent(token)}/file`}
              target="_blank"
              rel="noreferrer"
            >
              <IconDownload size={18} aria-hidden="true" /> Openen
            </a>
            <p className="muted small">Deze link werkt tot {fmtDate(d.expiresAt)}.</p>
          </>
        )}
      </main>
    </div>
  );
}
